define('supplierImprintTechnologiesFiltersView',[
  'module',
  'backbone',
  'underscore',
  'settings',
  'supplierImprintTechnologiesFiltersEditView',
  'filtersBannerView'
], function (
  Module,
  Backbone,
  _,
  Settings,
  EditView,
  FiltersBannerView
) {
  'use strict';

  Module.exports = FiltersBannerView.extend({
    editViewClass: EditView,

    initialize: function () {
      this.tableView = this.options.tableView;
      var settings = Settings.get('supplierImprintTechnologiesFilters', true);
      if (settings) {
        this.model = new Backbone.Model(JSON.parse(settings));
      } else {
        this.model = new Backbone.Model({
          code: '',
          supplier: '',
          name: '',
          maxNumberOfColors: ''
        });
        Settings.set('supplierImprintTechnologiesFilters', JSON.stringify(this.model.attributes), true);
      }
      this.tableView.filters = this.model;

      FiltersBannerView.prototype.initialize.apply(this, arguments);
    },

    setCollection: function () {
      // Code
      if (this.model.get('code')) {
        this.collection.add(new Backbone.Model({
          id: 'code',
          libelle: _.i18n('common.code'),
          value: this.model.get('code')
        }));
      }

      // Supplier
      if (this.model.get('supplier')) {
        this.collection.add(new Backbone.Model({
          id: 'supplier',
          libelle: _.i18n('product.supplier'),
          value: this.model.get('supplier')
        }));
      }

      // Name
      if (this.model.get('name')) {
        this.collection.add(new Backbone.Model({
          id: 'name',
          libelle: _.i18n('common.name'),
          value: this.model.get('name')
        }));
      }

      // Max number of colors
      if (this.model.get('colorModeType') !== '' && this.model.get('colorModeType') !== null) {
        this.collection.add(new Backbone.Model({
          id: 'colorModeType',
          libelle: _.i18n('imprintTechnology.colorModeType'),
          value: this.model.get('colorModeType')
        }));
      }

      // Max number of colors
      if (this.model.get('maxNumberOfColors') !== '' && this.model.get('maxNumberOfColors') !== null) {
        this.collection.add(new Backbone.Model({
          id: 'maxNumberOfColors',
          libelle: _.i18n('imprintTechnology.maxNumberOfColors'),
          value: this.model.get('maxNumberOfColors')
        }));
      }

      FiltersBannerView.prototype.setCollection.apply(this, arguments);
    },

    fetch: function (model) {
      var needFetch = false;

      if (this.model.get('code') !== model.code) needFetch = true;
      if (this.model.get('supplier') !== model.supplier) needFetch = true;
      if (this.model.get('name') !== model.name) needFetch = true;
      if (this.model.get('colorModeType') !== model.colorModeType) needFetch = true;
      if (this.model.get('maxNumberOfColors') !== model.maxNumberOfColors) needFetch = true;

      FiltersBannerView.prototype.fetch.apply(this, arguments);
      Settings.set('supplierImprintTechnologiesFilters', JSON.stringify(this.model.attributes), true);

      if (needFetch) {
        if (this.tableView && this.tableView.footerView && this.tableView.bodyView) {
          this.tableView.footerView.setCurrentPage(1);
          this.tableView.bodyView.fetch();
          this.tableView.footerView.fetch();
        } else if (this.tableView && this.tableView.reload) {
          this.tableView.reload();
        }
      }
    }
  });
});

